import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Pagetitlesection from "../components/pagetitlesection";
import { FaArrowRight } from "react-icons/fa";
import homebanner from "../assets/home-banner.png";
import "../NewsListing.scss";

const ArchivePage = () => {
  const { month } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [articlesPerPage] = useState(6);

  useEffect(() => {
    if (!month) return;

    const fetchArticles = async () => {
      try {
        const res = await fetch(`/php-api/get_archives.php?month=${encodeURIComponent(month)}`);
        const data = await res.json();
        if (data.success && Array.isArray(data.articles)) {
          setArticles(data.articles);
        } else {
          setError(data.message || "No articles found for this archive.");
        }
      } catch (err) {
        setError("Failed to load archive.");
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [month]);

  // Pagination
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);
  const totalPages = Math.ceil(articles.length / articlesPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <div className="loading">Loading archive...</div>;
  if (error) return <div className="error">{error}</div>;

  const displayMonth = month
    .split("-")
    .map((word, idx) => (idx === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ");

  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title={`Archive: ${displayMonth}`} backgroundImage={homebanner} />

        <div className="news-listing-container">
          <div className="news-grid">
            {currentArticles.length > 0 ? (
              currentArticles.map((article) => (
                <div key={article.id} className="news-card">
                  {article.image_url ? (
                    <div className="news-card-image">
                      <img src={article.image_url} alt={article.title || "Article"} />
                    </div>
                  ) : (
                    <div className="news-card-image placeholder">No Image</div>
                  )}

                  <div className="news-card-content">
                    <h2 className="news-card-title">{article.title || "Untitled Article"}</h2>

                    <div className="news-card-meta">
                      <span className="publish-date">
                        {article.publishDate
                          ? new Date(article.publishDate).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                          : "No date"}
                      </span>
                      {article.category && <span className="category">{article.category}</span>}
                    </div>

                    <div
                      className="news-card-excerpt"
                      dangerouslySetInnerHTML={{
                        __html:
                          article.excerpt ||
                          (article.content
                            ? article.content.substring(0, 150) + "..."
                            : "No summary available."),
                      }}
                    />

                    <Link to={`/news/${article.slug || "#"}`} className="read-more-btn">
                      Read More <FaArrowRight />
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-articles">No articles found for this archive.</div>
            )}
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                Previous
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                <button
                  key={number}
                  onClick={() => paginate(number)}
                  className={`pagination-btn ${currentPage === number ? "active" : ""}`}
                >
                  {number}
                </button>
              ))}

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-btn"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArchivePage;
